export enum RoutePaths {
  Home = '/',
  ProgramDashboard = '/program-dashboard',
  JudgingDashboard = '/judging-dashboard',
  OperationDashboard = '/operation-dashboard',
  Nominate = '/nominate',
  Nominations = '/nominations',
  Inspire = 'https://ignite.microsoft.com/en-US/home',
  Awards = '/awards',
  EditAwardDetail = '/edit-award-detail',
  CountryAward = '/country-award',
  Countries = '/countries',
  AwardResources = '/award-resources',
  JudgingResources = '/judging-resources',
  SelectAward = '/select-award',
  ReviewAndSubmit = '/review-and-submit',
  UserProfile = '/user-profile',
  EditRegional = '/edit-regional',
  Email = '/email',
  Programs = '/programs',
  ProgramDates = '/program-dates',
  ManageAwardList = '/manage-award-list',
  WinnerRequirement = '/winner-requirement',
  Winners = '/winners',
  Questionnaires = '/questionnaires',
  ReviewQuestionnaire = '/review-questionnaire',
  Notifications = '/notifications',
  UserResources = '/user-resources',
  WinnersAndFinalists = '/winners-and-finalists',
  EoNoAccess = '/eo-no-access',
  NotFound = '/not-found',
}
